import { useEffect, useState } from 'react';
import { EOrganization, ESnapshotExists, exists } from 'lib/types';
import { affidavitsAreManagedByColumn } from 'lib/affidavits';
import { useLocation } from 'react-router-dom';
import { MAIN_ROUTES } from 'router/routes';

export const useDetermineShowAutomatedAffidavitsTab = (
  activeOrganization: ESnapshotExists<EOrganization> | null
) => {
  const { pathname } = useLocation();
  const [showAutomatedAffidavitsTab, setShowAutomatedAffidavitsTab] =
    useState(false);

  const reloadTab = () => {
    if (pathname.startsWith(MAIN_ROUTES.AFFIDAVITS)) {
      setShowAutomatedAffidavitsTab(true);
      return;
    }
    setShowAutomatedAffidavitsTab(
      exists(activeOrganization) &&
        affidavitsAreManagedByColumn(activeOrganization)
    );
  };
  useEffect(() => {
    reloadTab();
  }, [activeOrganization?.id]);

  return showAutomatedAffidavitsTab;
};
